import { Agent } from './agent';
import { AgentGroup } from './agent-group';
import { Company } from './company';
import { Dependent } from './dependent';
import { Funder } from './funder';
import { Member } from './member';
import { Provider } from './provider';
import { UserPermission } from './user-permission';

export class User {
  user_uuid!: string;
  name!: string;
  email?: string;
  role!: string;
  affiliation!: string;
  // B-FORCE-PASSWORD (Atenza parity) — true while the user must set a new, strong password.
  password_change_required?: boolean;
  national_id!: string;
  phone_number!: string;
  user_id?: number;
  company_number?: string;
  ahfoz_number?: string;
  agent_group_number?: string;
  agent_number?: string;
  member_number?: string;
  beneficiary_number?: string;
  status?: string;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  member?: Member;
  dependent?: Dependent;
  company?: Company;
  provider?: Provider;
  agent?: Agent;
  agent_group?: AgentGroup;
  permissions?: UserPermission;
  user_avatar_path?: string;
  portal_logo_path?: string;
  primary_color?: string;

  funder?: Funder;

  constructor(data: any) {
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.national_id = data.national_id;
    this.phone_number = data.phone_number;
    this.email = data.email;
    this.role = data.role;
    this.affiliation = data.affiliation;
    this.password_change_required = data.password_change_required;
    this.user_id = data.user_id;
    this.company_number = data.company_number;
    this.ahfoz_number = data.ahfoz_number;
    this.agent_group_number = data.agent_group_number;
    this.agent_number = data.agent_number;
    this.member_number = data.member_number;
    this.beneficiary_number = data.beneficiary_number;
    this.status = data.status;
    this.uuid = data.uuid;

    this.primary_color = data.primary_color;
    this.user_avatar_path = data.user_avatar_path;
    this.portal_logo_path = data.portal_logo_path;

    if (data.user) {
      this.user = new User(data.user);
    }

    if (data.company) {
      this.company = new Company(data.company);
    }

    if (data.funder) {
      this.funder = new Funder(data.funder);
    }

    if (data.provider) {
      this.provider = new Provider(data.provider);
    }

    if (data.dependent) {
      this.dependent = new Dependent(data.dependent);
    }

    if (data.member) {
      this.member = new Member(data.member);
    }

    if (data.agent_group) {
      this.agent_group = new AgentGroup(data.agent_group);
    }

    if (data.agent) {
      this.agent = new Agent(data.agent);
    }

    if (data.permissions) {
      this.permissions = new UserPermission(data.permissions);
    }
  }

  isActive() {
    return this.status?.toLocaleLowerCase() == 'active';
  }

  isAdmin(): boolean {
    return this.role.toLowerCase() === 'admin';
  }

  isSuperAdmin(): boolean {
    return this.role.toLowerCase() === 'super_admin';
  }

  isTeleSales(): boolean {
    return this.role.toLowerCase() === 'tele_sales';
  }

  isMembershipClerk(): boolean {
    return this.role.toLowerCase() === 'membership_clerk';
  }

  isMembershipSupervisor(): boolean {
    return this.role.toLowerCase() === 'membership_supervisor';
  }

  isClaimsAnalyst(): boolean {
    return this.role.toLowerCase() === 'claims_analyst';
  }

  isClaimsSupervisor(): boolean {
    return this.role.toLowerCase() === 'claims_supervisor';
  }

  isAffiliationIsAdmin(): boolean {
    return this.affiliation.toLowerCase() === 'admin';
  }

  isAffiliationIsFunder(): boolean {
    return this.affiliation.toLowerCase() === 'funder';
  }
  isAffiliationIsProvider(): boolean {
    return this.affiliation.toLowerCase() === 'provider';
  }
  isAffiliationIsCompany(): boolean {
    return this.affiliation.toLowerCase() === 'company';
  }
  isAffiliationIsMember(): boolean {
    return this.affiliation.toLowerCase() === 'member';
  }
  isAffiliationIsAgentGroup(): boolean {
    return this.affiliation.toLowerCase() === 'agent_group';
  }


  isGeneral(): boolean {
    return this.role === 'General';
  }

  isSalesperson(): boolean {
    return this.role === 'Salesperson';
  }
}
